import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import Table, { useTable } from 'common/components/table';
import { useActions } from 'utils/hooks';
import * as airportActions from 'store/airports/actions';

import TableActions from 'components/layouts/table';

import edit from 'assets/svg/actions/edit.svg';
import archive from 'common/assets/svg/actions/archive.svg';
import unarchive from 'common/assets/svg/actions/unarchive.svg';

import useDrawer from 'common/components/drawer/useDrawer';
import Form from './form';
import EnumsDropdown from '../Dropdown';
import AirportTypeSelector from 'components/selectors/AirportTypeSelector';
import CountrySelector from 'common/components/selectors/CountrySelector';

const Airports = () => {
  const [active, setActive] = useState(null);

  const [archiveAirport, unArchiveAirport] = useActions([
    airportActions.archiveAirport,
    airportActions.unArchiveAirport
  ]);

  const drawer = useDrawer();

  const table = useTable({
    label: 'airports',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true
      },
      {
        header: 'Iata Code',
        key: 'iata_code',
        type: 'string',
        sort: true
      },
      {
        header: 'Coordinates',
        key: 'coordinates',
        type: 'string',
        sort: false,
        canFilter: false,
        className: 'coordinates-cell'
      },
      {
        header: 'Country',
        key: 'country',
        type: 'collection',
        component: CountrySelector,
        componentRest: { isMulti: true },
        sort: true
      },
      {
        header: 'Timezone',
        key: 'timezone',
        type: 'string',
        sort: true
      },
      {
        header: 'Type',
        key: 'airport_type',
        type: 'collection',
        component: AirportTypeSelector,
        componentRest: { isMulti: true },
        sort: true
      },
      {
        header: 'Elevation',
        key: 'elevation',
        className: 'text-start',
        type: 'number',
        sort: true
      },
      {
        header: 'Iso Region',
        key: 'iso_region',
        type: 'string',
        sort: true
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center',
        width: 1
      }
    ],
    top: {
      filters: [{ name: 'archived', operation: '=', value: null }]
    }
  });

  return (
    <Row className="airports-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="Airports"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[
            { type: 'search' },
            {
              type: 'add',
              text: 'Add Airport',
              color: 'primary',
              onClick: () => {
                setActive(null);
                drawer.open();
              }
            }
          ]}
        />
      </Col>

      <Col xs={12}>
        <Table
          loader
          showArchived
          drawer={<Form drawer={drawer} active={active} />}
          onArchive={archiveAirport}
          onUnarchive={unArchiveAirport}
          rows={{
            country: data => <div>{data.country.name}</div>,
            timezone: data => <div>{data.timezone}</div>,
            airport_type: data => <div>{data.airport_type && data.airport_type.name}</div>,
            coordinates: data => (
              <div>
                {data.lat} / {data.lon}
              </div>
            ),
            actions: data => ({
              options: [
                {
                  label: data.is_archived ? 'Unarchive' : 'Archive',
                  icon: data.is_archived ? unarchive : archive,
                  isArchived: data.is_archived,
                  modal: true,
                  header: data.is_archived ? 'Unarchive' : 'Archive',
                  body: (
                    <div className="text-center">
                      You are about to {data.is_archived ? 'unarchive' : 'archive'} this airport.{' '}
                      <br />
                      Are you sure you want to continue?
                    </div>
                  )
                },
                {
                  label: 'Edit',
                  icon: edit,
                  onClick: (_, row) => {
                    setActive(row);
                    drawer.open();
                  }
                }
              ]
            })
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default Airports;
